import reactUpdate from 'immutability-helper';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';
import _ from 'underscore';

const TRAY_TASK_DEFAULTS = {
  heading: '',
  onHeadingClick: undefined,
  subheading: '',
  onSubheadingClick: undefined,
  icon: undefined,
  progress: 0, // value between 0 and 1 or one of the constants in TrayTaskConstants
  error: '',
};

class TrayTaskStore extends Store {
  resetState() {
    // @tasks is an array, not a dictionary, because its eventual purpose is to be ordered in a view. We still
    // key to it with an id (rather than an index) because tasks can be arbitrarily removed, and it's a lot
    // easier to keep track of them through constant ids rather than changing indices.
    this.tasks = [];
    this.isTrayOpen = false;
  }

  getState() {
    return {
      tasks: this.tasks,
      isTrayOpen: this.isTrayOpen,
    };
  }

  getTask(id) {
    // eslint-disable-next-line no-restricted-syntax
    return _.find(this.tasks, {id});
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.TRAY_TASK_ADD:
        this.addTrayTask(action.taskId, action.options);
        this.emitChange();
        break;

      case EventConstants.TRAY_TASK_UPDATE:
        this.updateTrayTask(action.taskId, action.options);
        this.emitChange();
        break;

      case EventConstants.TRAY_TASK_REMOVE:
        this.removeTrayTask(action.taskId);
        this.emitChange();
        break;

      case EventConstants.TRAY_TASK_TOGGLE_OPEN:
        this.isTrayOpen = !this.isTrayOpen;
        this.emitChange();
        break;

      case EventConstants.TRAY_TASK_SHOW:
        this.isTrayOpen = true;
        this.emitChange();
        break;

      case EventConstants.TRAY_TASK_HIDE:
        this.isTrayOpen = false;
        this.emitChange();
        break;

      default:
        break;
    }

    return true;
  }

  addTrayTask(taskId, options) {
    if (this.getTask(taskId) != null) {
      throw new Error(`Task with id ${taskId} already exists`);
    }

    const task = _.defaults({}, options, TRAY_TASK_DEFAULTS);
    task.id = taskId;
    this.tasks.push(task);
  }

  updateTrayTask(taskId, options) {
    // eslint-disable-next-line no-restricted-syntax
    const index = _.findIndex(this.tasks, {id: taskId});
    if (index === -1) {
      return;
    }
    const task = this.tasks[index];

    const newTask = reactUpdate(task, {$merge: options});
    this.tasks = reactUpdate(this.tasks, {
      $splice: [[index, 1, newTask]],
    });
  }

  removeTrayTask(taskId) {
    // eslint-disable-next-line no-restricted-syntax
    const index = _.findIndex(this.tasks, {id: taskId});
    if (index === -1) {
      return;
    }
    this.tasks = reactUpdate(this.tasks, {
      $splice: [[index, 1]],
    });
  }
}

export default new TrayTaskStore(AppDispatcher);
